import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { 
  Calendar, Clock, Users, MapPin, Car, Zap, 
  ChevronDown, ChevronUp, Sparkles, Trophy,
  Target, Shield, Gauge, Flag,
  Phone, Mail, CheckCircle2, ArrowRight, Download, Utensils
} from 'lucide-react';

// Configure pdfMake fonts
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

const BestDriveFleetPage = () => {
  const [expandedVariant, setExpandedVariant] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);

  const toggleVariant = (variantId) => {
    setExpandedVariant(expandedVariant === variantId ? null : variantId);
  };

  const selectVariant = (variant) => {
    setSelectedVariant(variant);
    setTimeout(() => {
      const pricingSection = document.getElementById('pricing-section');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 300);
  };

  // Event variants data
  const variants = [
    {
      id: 1,
      name: 'Automotodrom Most - Kurz bezpečné jízdy',
      location: 'Most, Tvrzova 5',
      type: 'Varianta A',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/c19rrexk_Sni%CC%81mek%20obrazovky%202026-03-24%20v%C2%A023.52.35.png',
      shortDesc: 'Profesionální kurz obranné jízdy s praktickým výcvikem na specializovaných plochách + Easydrift',
      price: 229403,
      priceBreakdown: {
        kurz: 164298,
        easydrift: 24000,
        catering: 20250,
        agentura: 20855
      },
      galleryImages: [
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/c19rrexk_Sni%CC%81mek%20obrazovky%202026-03-24%20v%C2%A023.52.35.png',
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/de1xj2li_Sni%CC%81mek%20obrazovky%202026-03-24%20v%C2%A023.52.24.png'
      ],
      activities: [
        { name: 'Teoretická část KBJ', duration: '60 min', icon: 'Target' },
        { name: 'Losí test', duration: '60 min', icon: 'Zap' },
        { name: 'Hydraulická kyvná deska', duration: '60 min', icon: 'Shield' },
        { name: 'Aquaplaning simulace', duration: '60 min', icon: 'Gauge' },
        { name: 'Kopec s kluznou plochou', duration: '60 min', icon: 'Flag' },
        { name: 'Easydrift', duration: '60 min', icon: 'Car' }
      ],
      schedule: [
        { time: '08:30 – 09:00', activity: 'Příjezd účastníků, parking, registrace' },
        { time: '09:00 – 10:00', activity: 'Teoretická část bezpečné jízdy' },
        { time: '10:00 – 12:00', activity: 'Praktický výcvik - rotace skupin (Losí test, Hydraulická deska)' },
        { time: '12:00 – 13:00', activity: 'Obědová pauza' },
        { time: '13:00 – 15:00', activity: 'Praktický výcvik - pokračování (Aquaplaning, Kopec)' },
        { time: '15:00 – 16:00', activity: 'Easydrift - adrenalinový zážitek' },
        { time: '16:00 – 16:30', activity: 'Ukončení akce, odjezd' }
      ],
      advantages: [
        'Profesionální kurz bezpečné jízdy pro 40 účastníků',
        'Praktický výcvik na specializovaných polygonech',
        'Easydrift - unikátní zážitek ovládání smyku',
        'Instruktoři s mnohaletou praxí',
        'Moderní závodní okruh s kompletním zázemím',
        'Parking zdarma, snadná dostupnost vlastní dopravou'
      ],
      why: 'Ideální varianta pro praktické zlepšení řidičských dovedností. Kurz bezpečné jízdy přímo navazuje na fleetový byznys - zvýšení bezpečnosti, snížení rizika nehod. Easydrift přidává zážitkovou složku.',
      contact: {
        person: 'Barbora Benešová',
        role: 'Event Manager',
        phone: '+420 720 827 493',
        email: 'info@autodrom-most.cz'
      },
      pdfUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/o804xod9_Firemni%CC%81%20akce%202027.pdf'
    },
    {
      id: 2,
      name: 'Automotodrom Most - Závodní zážitek',
      location: 'Most, Tvrzova 5',
      type: 'Varianta B',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/pjomyd3f_Sni%CC%81mek%20obrazovky%202026-03-24%20v%C2%A023.58.34.png',
      shortDesc: 'Kurz bezpečné jízdy + jízda na závodní dráze v profesionálních OCR speciálech',
      price: 235563,
      priceBreakdown: {
        kurz: 164298,
        zavodni_draha: 21500,
        jizda_ocr: 8100,
        catering: 20250,
        agentura: 21415
      },
      galleryImages: [
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/pjomyd3f_Sni%CC%81mek%20obrazovky%202026-03-24%20v%C2%A023.58.34.png',
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/2na3eyhi_Sni%CC%81mek%20obrazovky%202026-03-24%20v%C2%A023.58.28.png'
      ],
      activities: [
        { name: 'Teoretická část KBJ', duration: '60 min', icon: 'Target' },
        { name: 'Losí test', duration: '60 min', icon: 'Zap' },
        { name: 'Hydraulická kyvná deska', duration: '60 min', icon: 'Shield' },
        { name: 'Aquaplaning simulace', duration: '60 min', icon: 'Gauge' },
        { name: 'Kopec s kluznou plochou', duration: '60 min', icon: 'Flag' },
        { name: 'Jízda v závodním speciálu OCR', duration: '2 kola', icon: 'Car' },
        { name: 'Taxi jízda s profesionálním pilotem', duration: '2 kola', icon: 'Trophy' }
      ],
      schedule: [
        { time: '08:30 – 09:00', activity: 'Příjezd účastníků, parking, registrace' },
        { time: '09:00 – 10:00', activity: 'Teoretická část bezpečné jízdy' },
        { time: '10:00 – 12:00', activity: 'Praktický výcvik - rotace skupin (Losí test, Hydraulická deska)' },
        { time: '12:00 – 13:00', activity: 'Obědová pauza' },
        { time: '13:00 – 15:00', activity: 'Praktický výcvik (Aquaplaning, Kopec)' },
        { time: '15:00 – 16:00', activity: 'Závodní dráha - jízda v OCR speciálech + taxi jízdy' },
        { time: '16:00 – 16:30', activity: 'Ukončení akce, odjezd' }
      ],
      advantages: [
        'Kompletní kurz bezpečné jízdy + závodní zážitek',
        'Jízda v profesionálních závodních speciálech OCR',
        'Taxi jízda s profesionálním pilotem na 4,2km okruhu',
        'Praktický výcvik na nejmodernějších polygonech',
        'Kombinace bezpečnosti a adrenalinu',
        'Instruktoři s licencí a závodní zkušeností'
      ],
      why: 'Prémiová varianta kombinující praktický trénink s nezapomenutelným závodním zážitkem. Jízda na profesionálním okruhu v OCR speciálech přináší vrcholný automotive experience pro fleet manažery.',
      contact: {
        person: 'Barbora Benešová',
        role: 'Event Manager',
        phone: '+420 720 827 493',
        email: 'info@autodrom-most.cz'
      },
      pdfUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/o804xod9_Firemni%CC%81%20akce%202027.pdf'
    },
    {
      id: 3,
      name: 'Den v Brně - Wellness & Gastro',
      location: 'Brno - Střelnice, Plavba, Maximus Resort',
      type: 'Varianta C',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/x2f5sifx_strelnice.jpg',
      shortDesc: 'Kombinace adrenalinu, relaxace a gastronomie - střelnice, plavba k Hradu Veveří, wellness a večeře',
      price: 200000,
      priceBreakdown: {
        strelnice: 45000,
        plavba: 40500,
        wellness: 45000,
        vecere: 27000,
        parkovani: 10000,
        koordinace: 10000,
        agentura: 22500
      },
      galleryImages: [
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/x2f5sifx_strelnice.jpg',
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/fkjmfmvf_plavba%20brno.jpg',
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/0ig7mmzb_maximus%20brnooo.jpg',
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/lji7x387_vec%CC%8Cer%CC%8Ce.webp'
      ],
      activities: [
        { name: 'Instruktážní střelba', duration: '120 min', icon: 'Target' },
        { name: 'Plavba lodí Bystrc - Hrad Veveří', duration: '120 min', icon: 'Flag' },
        { name: 'Wellness & Saunový svět', duration: '180 min', icon: 'Sparkles' },
        { name: 'Večeře v restauraci Maximus', duration: '60 min', icon: 'Trophy' }
      ],
      schedule: [
        { time: '09:00 – 09:30', activity: 'Příjezd účastníků, parking, registrace' },
        { time: '09:30 – 11:30', activity: 'Střelnice - instruktážní střelba (120 min)' },
        { time: '11:30 – 12:00', activity: 'Přesun na přístaviště Bystrc' },
        { time: '12:00 – 14:00', activity: 'Plavba lodí s cateringem (Bystrc → Hrad Veveří)' },
        { time: '14:00 – 14:30', activity: 'Přesun do Maximus Resort Brno' },
        { time: '14:30 – 17:30', activity: 'Wellness & Saunový svět (180 min)' },
        { time: '17:30 – 18:00', activity: 'Volný čas, příprava na večeři' },
        { time: '18:00 – 19:00', activity: 'Večeře v prémiové restauraci Maximus' },
        { time: '19:00 – 19:30', activity: 'Ukončení akce, odjezd' }
      ],
      advantages: [
        'Přesně v rozpočtu 200 000 Kč',
        'Kombinace adrenalinu (střelnice), relaxace (wellness) a kultury (hrad)',
        'Maximus Resort - nejlepší wellness centrum v Brně',
        'Plavba lodí s výhledem na historický Hrad Veveří',
        'Prémiová večeře v top restauraci',
        'Parkování zajištěno, snadná dostupnost z Prahy'
      ],
      why: 'Ideální varianta pro klienty, kteří preferují kombinaci zážitků. Střelnice poskytuje týmovou aktivitu a adrenalin, plavba s obědem relaxační prvek a networking, wellness kompletní odpočinek a večeře ve stylové restauraci uzavírá den v příjemné atmosféře.',
      shootingDetails: {
        title: 'Střelecký program',
        stations: [
          {
            name: 'Stanoviště A – přesná střelba',
            weapon: 'Glock 19',
            description: 'Moderní služební pistole, která patří mezi nejrozšířenější zbraně na světě. Nabízí velmi komfortní a intuitivní střelbu v ráži 9 mm, díky čemuž je ideální i pro účastníky bez předchozích zkušeností.',
            activity: 'Na tomto stanovišti probíhá střelba na klasické terče s důrazem na přesnost a základní techniku.'
          },
          {
            name: 'Stanoviště B – dynamická střelba',
            weapon: 'Scorpion EVO',
            description: 'Moderní český samopal s výbornou ergonomií a minimálním zpětným rázem. Díky kolimátoru je střelba velmi přesná a zároveň zábavná.',
            activity: 'Účastníci si vyzkouší dynamickou střelbu na kovové terče („poppery"), která přináší okamžitou zpětnou vazbu a výrazný zážitkový efekt.'
          }
        ]
      },
      contact: {
        person: 'Ondruchová Monika',
        role: 'Event Manager',
        phone: '+420 773 550 880',
        email: 'info@vseproakci.cz'
      },
      isPlaceholder: false
    },
    {
      id: 4,
      name: 'Polygon MAX CARS - Škola smyku',
      location: 'Dlouhá Lhota u Dobříše, okr. Příbram',
      type: 'Varianta D',
      image: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/7ij7a3we_Sni%CC%81mek%20obrazovky%202026-03-25%20v%C2%A08.28.57.png',
      shortDesc: 'Největší polygon v ČR - Škola smyku s rotací na 4 stanovištích + catering',
      price: 201190,
      priceBreakdown: {
        skola_smyku: 67000,
        priprava: 10000,
        drift: 30000,
        zrucnost: 20000,
        zazemi: 25000,
        ucebna: 12000,
        sleva: -54000,
        catering: 61900,
        agentura: 18290
      },
      galleryImages: [
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/7ij7a3we_Sni%CC%81mek%20obrazovky%202026-03-25%20v%C2%A08.28.57.png',
        'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/t25iksdk_Sni%CC%81mek%20obrazovky%202026-03-25%20v%C2%A08.28.50.png'
      ],
      activities: [
        { name: 'Škola smyku - Kluzná rovina', duration: '40 min', icon: 'Car' },
        { name: 'Kluzný kruh 360° - Drift soutěž', duration: '40 min', icon: 'Zap' },
        { name: 'Aqua vana + Kluzná zatáčka', duration: '40 min', icon: 'Gauge' },
        { name: 'Jízda zručnosti - Soutěž míček', duration: '40 min', icon: 'Target' }
      ],
      schedule: [
        { time: '11:45 – 12:45', activity: 'Ranní příprava akce' },
        { time: '12:45 – 13:30', activity: 'Příjezd klientů + zahájení akce + catering' },
        { time: '13:30 – 17:30', activity: 'Program - 5× slot po 40 min (rotace stanovišť)' },
        { time: '17:30 – 18:00', activity: 'Vyhlášení soutěží, ukončení aktivního programu' },
        { time: '18:00 – 19:00', activity: 'Odjezd klientů, likvidace, úklid' }
      ],
      advantages: [
        'Největší polygon v České republice',
        'Akreditované školící středisko bezpečné jízdy',
        'Rotace 4 stanovišť - každý si vyzkouší vše',
        'Profesionální vozidla MAX CARS (Nissan 370Z, Škoda elektromobily)',
        'Kompletní zázemí - showroom s terasou, učebna, venkovní posezení až 80 osob',
        'Možnost brandingu celého areálu a vystavení produktů',
        'Snack catering od Restaurace Srdcovka + neomezené nealko nápoje'
      ],
      why: 'Unikátní kombinace praktické školy smyku na vlastních vozech s adrenalinovými aktivitami na profesionálních vozidlech. Ideální pro fleet management - zvýšení bezpečnosti řidičů s prvky soutěže a team buildingu. Největší polygon v ČR s kompletním zázemím pro corporate akce.',
      polygonDetails: {
        title: 'Detaily polygonu a stanovišť',
        stations: [
          {
            name: 'Stanoviště A – Škola smyku / Kluzná rovina',
            vehicle: 'Vlastní vozidla klientů',
            description: 'Regresivní brzdění při různých rychlostech až do úplného zastavení. Brzdění a zatáčení. Váhový přenos vozidla v dvojité a trojité zatáčce. Brzdění na rozdílných površích. Vyhýbací manévry s brzděním i bez brzdění. Zvládání nedotáčivosti a přetáčivosti.',
            area: 'Kluzná rovina 10 × 90 m, Losí test, vyhýbací manévr 50/50'
          },
          {
            name: 'Stanoviště B – Kluzný kruh 360° / Drift soutěž',
            vehicle: 'Nissan 370Z Nismo (manuál, zadní pohon)',
            description: 'Instruktor ve vozidle. Soutěž o nejvyšší % projití kruhu v driftu. Profesionální závodní vůz s výbornou ergonomií.',
            area: 'Kluzná kružnice 360° o poloměru 28 m a šířce 8 m'
          },
          {
            name: 'Stanoviště C – Aqua vana + Kluzná zatáčka',
            vehicle: 'Vlastní vozidla / MAX CARS',
            description: 'Simulace aquaplaningu a zvládání smyku v kluzné zatáčce. Praktický trénink pro reálné situace na mokré vozovce.',
            area: 'Aquaplaningová vana 5 × 50 m, Kluzná zatáčka 8 × 60 m'
          },
          {
            name: 'Stanoviště D – Jízda zručnosti / Soutěž "míček na kapotě"',
            vehicle: 'Škoda elektromobil',
            description: 'Precizní ovládání vozu při nízké rychlosti. Soutěž s časomírou a míčkem na kapotě. Rozvoj jemné motoriky a citlivosti k vozu.',
            area: 'Specializovaná dráha s překážkami a časomírou'
          }
        ]
      },
      cateringDetails: {
        title: 'Snack catering (Restaurace Srdcovka Dobříš)',
        items: [
          'Roastbeef', 
          'Chlebíčky s prosciuttem', 
          'Caprese špízy', 
          'Sýrový talíř s ovocem',
          'Mini řízečky mix (kuřecí-vepřové)', 
          'Mini burgery', 
          'Pěna z modrého sýra s čerstvou zeleninou',
          'Panenka s pečenou cibulí a křenem', 
          'Onigiri s uzeným lososem',
          'Dezerty: Panacotta, Brownies'
        ],
        drinks: 'Neomezené nealko nápoje: Točené nealko pivo, domácí limonády, minerální vody, juice, káva, čaj'
      },
      contact: {
        person: 'MAX CARS Training s.r.o.',
        role: 'Event Manager',
        phone: '+420 XXX XXX XXX',
        email: 'info@maxcars.cz'
      },
      pdfUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/k1bpl93m_Nabi%CC%81dka%20pro%20klienty%20ag.%20EVENT-TIME%20-%20event%20akce%20S%CC%8Ckola%20smyku%20s%20doprovodny%CC%81mi%20programy%20r.2027.pdf',
      cateringPdfUrl: 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/49ojtfpw_Raut%20Polygon%20by%20Dobr%CC%8Ci%CC%81s%CC%8C%20Srdcovka-Zasta%CC%81vka%20pro%20EVENT-TIME%20r.2027%2045%20osob.pdf',
      isPlaceholder: false
    }
  ];

  // Export to PDF function
  const exportToPDF = () => {
    if (!selectedVariant) {
      alert('Prosím vyberte nejprve variantu eventu');
      return;
    }

    try {
      console.log('🔄 Začínám generovat PDF pro:', selectedVariant.name);

    const docDefinition = {
      content: [
        // Header
        { text: 'OBCHODNÍ NABÍDKA', style: 'header', alignment: 'center', margin: [0, 0, 0, 10] },
        { text: 'VIP Event pro fleetové zákazníky BestDrive', style: 'subheader', alignment: 'center', margin: [0, 0, 0, 30] },
        
        // Selected Variant
        { text: 'VYBRANÁ VARIANTA', style: 'sectionHeader', margin: [0, 20, 0, 10] },
        {
          table: {
            widths: ['*', 'auto'],
            body: [
              [{ text: 'Varianta', bold: true }, { text: selectedVariant.name, alignment: 'right' }],
              [{ text: 'Lokace', bold: true }, { text: selectedVariant.location, alignment: 'right' }],
              [{ text: 'Kapacita', bold: true }, { text: '45 osob (40 zákazníků + 5 CTS)', alignment: 'right' }],
              [{ text: 'Termín', bold: true }, { text: 'Květen / Červen 2027', alignment: 'right' }]
            ]
          },
          margin: [0, 0, 0, 20]
        },

        // Program
        { text: 'PROGRAM DNE', style: 'sectionHeader', margin: [0, 20, 0, 10] },
        {
          table: {
            widths: ['auto', '*'],
            body: selectedVariant.schedule.map(item => [
              { text: item.time, bold: true },
              item.activity
            ])
          },
          margin: [0, 0, 0, 20]
        },

        // Price Breakdown
        { text: 'CENOVÁ KALKULACE', style: 'sectionHeader', margin: [0, 20, 0, 10] },
        {
          table: {
            widths: ['*', 'auto'],
            body: [
              ...(selectedVariant.priceBreakdown.kurz ? [['Kurz bezpečné jízdy (40 osob)', { text: selectedVariant.priceBreakdown.kurz.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.easydrift ? [['Easydrift (4 hodiny)', { text: selectedVariant.priceBreakdown.easydrift.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.zavodni_draha ? [['Závodní dráha', { text: selectedVariant.priceBreakdown.zavodni_draha.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.jizda_ocr ? [['Jízda v OCR speciálech', { text: selectedVariant.priceBreakdown.jizda_ocr.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.catering ? [['Catering - oběd a svačina vč. nápojového režimu (45 osob × 450 Kč)', { text: selectedVariant.priceBreakdown.catering.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.strelnice ? [['Střelnice (45 osob × 1 000 Kč)', { text: selectedVariant.priceBreakdown.strelnice.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.plavba ? [['Plavba lodí s cateringem (45 osob × 900 Kč)', { text: selectedVariant.priceBreakdown.plavba.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.wellness ? [['Wellness & Sauny Maximus (45 osob × 1 000 Kč)', { text: selectedVariant.priceBreakdown.wellness.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.vecere ? [['Večeře v restauraci (45 osob × 600 Kč)', { text: selectedVariant.priceBreakdown.vecere.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.parkovani ? [['Parkování', { text: selectedVariant.priceBreakdown.parkovani.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.koordinace ? [['Koordinace (2 osoby)', { text: selectedVariant.priceBreakdown.koordinace.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.agentura ? [[selectedVariant.id === 3 ? 'Provize agentury, zajištění, doprava' : selectedVariant.id === 4 ? 'Agenturní provize (10 %)' : 'Agenturní fee (10 %)', { text: selectedVariant.priceBreakdown.agentura.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.skola_smyku ? [['Škola smyku (4 hod, 45 osob)', { text: selectedVariant.priceBreakdown.skola_smyku.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.priprava ? [['Příprava + likvidace odpadů', { text: selectedVariant.priceBreakdown.priprava.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.drift ? [['Kluzná kružnice - Drift', { text: selectedVariant.priceBreakdown.drift.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.zrucnost ? [['Jízda zručnosti', { text: selectedVariant.priceBreakdown.zrucnost.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.zazemi ? [['Pronájem zázemí Touax', { text: selectedVariant.priceBreakdown.zazemi.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.ucebna ? [['Učebna pro prezentaci', { text: selectedVariant.priceBreakdown.ucebna.toLocaleString('cs-CZ') + ' Kč', alignment: 'right' }]] : []),
              ...(selectedVariant.priceBreakdown.sleva ? [['Poskytnutá sleva', { text: selectedVariant.priceBreakdown.sleva.toLocaleString('cs-CZ') + ' Kč', alignment: 'right', color: '#22c55e' }]] : []),
              [{ text: 'CELKEM', bold: true, fillColor: '#f0f0f0' }, { text: selectedVariant.price.toLocaleString('cs-CZ') + ' Kč bez DPH', bold: true, alignment: 'right', fillColor: '#f0f0f0' }]
            ]
          },
          margin: [0, 0, 0, 30]
        },

        // Footer
        { text: 'Podmínky:', bold: true, margin: [0, 20, 0, 5] },
        {
          ul: [
            'Maximální rozpočet: 200 000 Kč bez DPH',
            'Kapacita: 45 osob (40 zákazníků + 5 CTS)',
            'Uvedené ceny jsou bez DPH',
            'Termín: květen / červen 2027'
          ],
          fontSize: 9
        },
        
        { text: '\n\nKontakt: info@vseproakci.cz | +420 773 550 880 | Ondruchová Monika', alignment: 'center', fontSize: 9, color: '#666666', margin: [0, 30, 0, 0] }
      ],
      styles: {
        header: {
          fontSize: 22,
          bold: true,
          color: '#FDB913'
        },
        subheader: {
          fontSize: 16,
          color: '#666666'
        },
        sectionHeader: {
          fontSize: 14,
          bold: true,
          color: '#FDB913'
        }
      },
      defaultStyle: {
        fontSize: 10
      }
    };

    pdfMake.createPdf(docDefinition).download(`BestDrive_Fleet_Event_${selectedVariant.type}.pdf`);
    console.log('✅ PDF úspěšně vygenerováno');
    } catch (error) {
      console.error('❌ Chyba při generování PDF:', error);
      alert('Chyba při generování PDF: ' + error.message);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white font-['IBM_Plex_Sans']">
      
      {/* Hero Section */}
      <HeroSection />

      {/* Concept Section */}
      <ConceptSection />

      {/* Key Parameters */}
      <ParametersSection />

      {/* Variant Selection */}
      <VariantSelectionSection 
        variants={variants}
        expandedVariant={expandedVariant}
        toggleVariant={toggleVariant}
        selectVariant={selectVariant}
      />

      {/* Pricing Section */}
      {selectedVariant && (
        <PricingSection 
          selectedVariant={selectedVariant}
          exportToPDF={exportToPDF}
        />
      )}

      {/* CTA Section */}
      <CTASection />
    </div>
  );
};

// Hero Section Component
const HeroSection = () => (
  <section className="relative h-screen flex items-center justify-center overflow-hidden">
    <div 
      className="absolute inset-0 bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1638729527592-5f71350f88c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxyYWNpbmclMjBjaXJjdWl0JTIwZHJpdmluZyUyMHRyYWluaW5nJTIwc2FmZXR5JTIwY291cnNlfGVufDB8fHx8MTc3NDM5MTkyM3ww&ixlib=rb-4.1.0&q=85)',
        filter: 'brightness(0.4)'
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/80" />
    
    <div className="relative z-10 text-center px-6 max-w-5xl">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="inline-block px-6 py-2 bg-[#FDB913]/10 border border-[#FDB913]/30 rounded-full mb-6">
          <span className="text-[#FDB913] font-semibold text-sm tracking-wider">EXKLUZIVNÍ VIP ZÁŽITEK</span>
        </div>
        
        <h1 className="font-['Exo_2'] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-tight">
          VIP Event pro fleetové<br />zákazníky BestDrive
        </h1>
        
        <p className="text-base md:text-lg text-zinc-300 mb-8 max-w-3xl mx-auto leading-relaxed">
          Poděkování za dlouhodobou spolupráci formou exkluzivního automotive zážitku
        </p>

        <div className="flex flex-wrap gap-6 justify-center text-sm">
          <div className="flex items-center gap-2">
            <Users className="w-5 h-5 text-[#FDB913]" />
            <span className="text-zinc-300">45 účastníků</span>
          </div>
          <div className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-[#FDB913]" />
            <span className="text-zinc-300">Květen / Červen</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-[#FDB913]" />
            <span className="text-zinc-300">Okolí Prahy</span>
          </div>
          <div className="flex items-center gap-2">
            <Car className="w-5 h-5 text-[#FDB913]" />
            <span className="text-zinc-300">Automotive Experience</span>
          </div>
        </div>
      </motion.div>
    </div>

    <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
      <ChevronDown className="w-8 h-8 text-[#FDB913]" />
    </div>
  </section>
);

// Concept Section
const ConceptSection = () => (
  <section className="py-24 px-6 bg-[#0A0A0A]">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-16">
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Koncept akce
        </h2>
        <p className="text-base md:text-lg text-zinc-400 max-w-3xl mx-auto">
          Exkluzivní VIP event pro klíčové fleetové partnery
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-[#FDB913] transition-all">
          <Trophy className="w-12 h-12 text-[#FDB913] mb-4" />
          <h3 className="text-xl font-bold mb-3">Poděkování</h3>
          <p className="text-zinc-400 text-sm leading-relaxed">
            Oceňujeme dlouhodobou spolupráci našich fleetových partnerů. Tento event je naším osobním děkovným gestem za důvěru a společné úspěchy.
          </p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-[#FDB913] transition-all">
          <Sparkles className="w-12 h-12 text-[#FDB913] mb-4" />
          <h3 className="text-xl font-bold mb-3">Posílení vztahů</h3>
          <p className="text-zinc-400 text-sm leading-relaxed">
            Formou exkluzivního automotive zážitku budujeme hlubší vztahy. Společně strávený den mimo kanceláře posiluje důvěru a dlouhodobé partnerství.
          </p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-[#FDB913] transition-all">
          <Shield className="w-12 h-12 text-[#FDB913] mb-4" />
          <h3 className="text-xl font-bold mb-3">Přidaná hodnota</h3>
          <p className="text-zinc-400 text-sm leading-relaxed">
            Profesionální kurz bezpečné jízdy přináší praktickou hodnotu pro fleet management - zvýšení bezpečnosti řidičů a snížení rizika nehod.
          </p>
        </div>
      </div>
    </div>
  </section>
);

// Parameters Section
const ParametersSection = () => (
  <section className="py-24 px-6 bg-[#050505]">
    <div className="max-w-6xl mx-auto">
      <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-12 text-center">
        Klíčové parametry akce
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 text-center">
          <Users className="w-10 h-10 text-[#FDB913] mx-auto mb-3" />
          <div className="text-3xl font-bold mb-2">45</div>
          <div className="text-sm text-zinc-400">Účastníků</div>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 text-center">
          <Calendar className="w-10 h-10 text-[#FDB913] mx-auto mb-3" />
          <div className="text-3xl font-bold mb-2">1</div>
          <div className="text-sm text-zinc-400">Den</div>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 text-center">
          <MapPin className="w-10 h-10 text-[#FDB913] mx-auto mb-3" />
          <div className="text-3xl font-bold mb-2">Praha</div>
          <div className="text-sm text-zinc-400">Okolí</div>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 text-center">
          <Car className="w-10 h-10 text-[#FDB913] mx-auto mb-3" />
          <div className="text-3xl font-bold mb-2">VIP</div>
          <div className="text-sm text-zinc-400">Automotive Zážitek</div>
        </div>
      </div>

      <div className="mt-12 bg-zinc-900 border border-zinc-800 rounded-xl p-8">
        <h3 className="text-xl font-bold mb-4 flex items-center gap-3">
          <Target className="w-6 h-6 text-[#FDB913]" />
          Cílová skupina
        </h3>
        <p className="text-zinc-400 text-sm leading-relaxed">
          <strong className="text-white">Demografie:</strong> 95 % muži, 5 % ženy, průměrný věk 45 let<br />
          <strong className="text-white">Účastníci:</strong> cca 40 klíčových fleetových zákazníků + 5 zaměstnanců CTS<br />
          <strong className="text-white">Doprava:</strong> Vlastní (parkování zajištěno)
        </p>
      </div>
    </div>
  </section>
);

// Variant Selection Section
const VariantSelectionSection = ({ variants, expandedVariant, toggleVariant, selectVariant }) => (
  <section className="py-24 px-6 bg-[#0A0A0A]">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-16">
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Vyberte variantu eventu
        </h2>
        <p className="text-base md:text-lg text-zinc-400 max-w-3xl mx-auto">
          Nabízíme výběr ze dvou automotive zážitků na Automotodromu Most + varianta Brno
        </p>
      </div>

      <div className="space-y-6">
        {variants.map((variant) => (
          <motion.div
            key={variant.id}
            className={`border rounded-2xl overflow-hidden transition-all ${
              expandedVariant === variant.id 
                ? 'border-[#FDB913] bg-zinc-900' 
                : 'border-zinc-800 bg-zinc-900/50 hover:border-zinc-700'
            }`}
            initial={false}
          >
            {/* Variant Header */}
            <button
              onClick={() => toggleVariant(variant.id)}
              className="w-full p-6 flex items-center justify-between text-left"
            >
              <div className="flex items-center gap-6 flex-1">
                <img 
                  src={variant.image} 
                  alt={variant.name}
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="flex-1">
                  <div className="text-xs text-[#FDB913] font-semibold mb-1">{variant.type}</div>
                  <h3 className="text-2xl font-bold mb-2">{variant.name}</h3>
                  <p className="text-sm text-zinc-400">{variant.location} • {variant.shortDesc}</p>
                </div>
              </div>

              <div className="flex items-center gap-6">
                {!variant.isPlaceholder && (
                  <div className="text-right">
                    <div className="text-3xl font-bold text-[#FDB913]">
                      {variant.price.toLocaleString('cs-CZ')} Kč
                    </div>
                    <div className="text-xs text-zinc-500">bez DPH</div>
                  </div>
                )}
                {expandedVariant === variant.id ? (
                  <ChevronUp className="w-6 h-6 text-[#FDB913]" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-zinc-400" />
                )}
              </div>
            </button>

            {/* Expanded Content */}
            <AnimatePresence>
              {expandedVariant === variant.id && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="px-6 pb-6 border-t border-zinc-800">
                    {variant.isPlaceholder ? (
                      <div className="py-12 text-center">
                        <Sparkles className="w-16 h-16 text-zinc-600 mx-auto mb-4" />
                        <p className="text-zinc-400 text-lg">
                          Program pro Brno bude doplněn v dalším kroku
                        </p>
                      </div>
                    ) : (
                      <>
                        {/* Images Gallery */}
                        <div className="grid md:grid-cols-2 gap-4 my-6">
                          {variant.galleryImages && variant.galleryImages.map((imgUrl, idx) => (
                            <img 
                              key={idx}
                              src={imgUrl} 
                              alt={`${variant.name} - fotka ${idx + 1}`}
                              className="w-full h-64 object-cover rounded-xl"
                            />
                          ))}
                        </div>

                        {/* Schedule */}
                        <div className="mb-8">
                          <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
                            <Clock className="w-5 h-5 text-[#FDB913]" />
                            Program dne
                          </h4>
                          <div className="bg-black/30 rounded-xl p-6 space-y-3">
                            {variant.schedule.map((item, idx) => (
                              <div key={idx} className="flex items-start gap-4">
                                <span className="text-[#FDB913] font-mono font-semibold text-sm whitespace-nowrap">
                                  {item.time}
                                </span>
                                <span className="text-zinc-300 text-sm">{item.activity}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Activities */}
                        <div className="mb-8">
                          <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
                            <Zap className="w-5 h-5 text-[#FDB913]" />
                            Aktivity
                          </h4>
                          <div className="grid md:grid-cols-2 gap-3">
                            {variant.activities.map((activity, idx) => (
                              <div key={idx} className="bg-black/30 rounded-lg p-4 flex items-center gap-3">
                                <CheckCircle2 className="w-5 h-5 text-[#FDB913] flex-shrink-0" />
                                <div>
                                  <div className="text-sm font-semibold">{activity.name}</div>
                                  <div className="text-xs text-zinc-500">{activity.duration}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Advantages */}
                        <div className="mb-8">
                          <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
                            <CheckCircle2 className="w-5 h-5 text-[#FDB913]" />
                            Výhody
                          </h4>
                          <ul className="space-y-2">
                            {variant.advantages.map((adv, idx) => (
                              <li key={idx} className="flex items-start gap-3 text-sm text-zinc-300">
                                <CheckCircle2 className="w-4 h-4 text-[#FDB913] mt-0.5 flex-shrink-0" />
                                {adv}
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* Why Choose */}
                        <div className="bg-[#FDB913]/5 border border-[#FDB913]/20 rounded-xl p-6 mb-6">
                          <h4 className="text-lg font-bold mb-3 text-[#FDB913]">Proč zvolit tuto variantu?</h4>
                          <p className="text-sm text-zinc-300 leading-relaxed">{variant.why}</p>
                        </div>

                        {/* Shooting Details (only for Brno variant) */}
                        {variant.shootingDetails && (
                          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 mb-6">
                            <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
                              <Target className="w-5 h-5 text-[#FDB913]" />
                              {variant.shootingDetails.title}
                            </h4>
                            <div className="space-y-6">
                              {variant.shootingDetails.stations.map((station, idx) => (
                                <div key={idx} className="border-l-4 border-[#FDB913] pl-4">
                                  <h5 className="font-bold text-white mb-2">{station.name}</h5>
                                  <div className="mb-2">
                                    <span className="text-[#FDB913] font-semibold">{station.weapon}</span>
                                  </div>
                                  <p className="text-sm text-zinc-400 mb-2 leading-relaxed">{station.description}</p>
                                  <p className="text-sm text-zinc-300 leading-relaxed">{station.activity}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Polygon Details (only for Polygon MAX CARS variant) */}
                        {variant.polygonDetails && (
                          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 mb-6">
                            <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
                              <Car className="w-5 h-5 text-[#FDB913]" />
                              {variant.polygonDetails.title}
                            </h4>
                            <div className="space-y-6">
                              {variant.polygonDetails.stations.map((station, idx) => (
                                <div key={idx} className="border-l-4 border-[#FDB913] pl-4">
                                  <h5 className="font-bold text-white mb-2">{station.name}</h5>
                                  <div className="mb-2">
                                    <span className="text-[#FDB913] font-semibold">{station.vehicle}</span>
                                  </div>
                                  <p className="text-sm text-zinc-400 mb-2 leading-relaxed">{station.description}</p>
                                  <p className="text-xs text-zinc-500 leading-relaxed">Plocha: {station.area}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Catering Details (only for Polygon MAX CARS variant) */}
                        {variant.cateringDetails && (
                          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 mb-6">
                            <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
                              <Utensils className="w-5 h-5 text-[#FDB913]" />
                              {variant.cateringDetails.title}
                            </h4>
                            <div className="mb-4">
                              <h5 className="font-semibold text-white mb-3 text-sm">Snack menu:</h5>
                              <div className="grid grid-cols-2 gap-2">
                                {variant.cateringDetails.items.map((item, idx) => (
                                  <div key={idx} className="flex items-center gap-2 text-sm text-zinc-300">
                                    <CheckCircle2 className="w-3 h-3 text-[#FDB913] flex-shrink-0" />
                                    {item}
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className="bg-[#FDB913]/10 border border-[#FDB913]/30 rounded-lg p-4">
                              <p className="text-sm text-zinc-300"><strong className="text-[#FDB913]">Nápoje:</strong> {variant.cateringDetails.drinks}</p>
                            </div>
                          </div>
                        )}

                        {/* Price Breakdown */}
                        <div className="mb-6">
                          <h4 className="text-lg font-bold mb-4">Rozpis nákladů</h4>
                          <div className="bg-black/30 rounded-xl p-6 space-y-2 text-sm">
                            {variant.priceBreakdown.kurz && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Kurz bezpečné jízdy (40 osob)</span>
                                <span className="font-semibold">{variant.priceBreakdown.kurz.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.easydrift > 0 && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Easydrift (4 hodiny)</span>
                                <span className="font-semibold">{variant.priceBreakdown.easydrift.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.zavodni_draha > 0 && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Závodní dráha (1 hodina)</span>
                                <span className="font-semibold">{variant.priceBreakdown.zavodni_draha.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.jizda_ocr > 0 && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Jízda v OCR speciálech + Taxi jízda</span>
                                <span className="font-semibold">{variant.priceBreakdown.jizda_ocr.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.catering > 0 && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Catering - oběd a svačina vč. nápojového režimu (45 osob × 450 Kč)</span>
                                <span className="font-semibold">{variant.priceBreakdown.catering.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.strelnice && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Střelnice (45 osob × 1 000 Kč)</span>
                                <span className="font-semibold">{variant.priceBreakdown.strelnice.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.plavba && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Plavba lodí s cateringem (45 osob × 900 Kč)</span>
                                <span className="font-semibold">{variant.priceBreakdown.plavba.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.wellness && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Wellness & Sauny Maximus (45 osob × 1 000 Kč)</span>
                                <span className="font-semibold">{variant.priceBreakdown.wellness.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.vecere && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Večeře v restauraci (45 osob × 600 Kč)</span>
                                <span className="font-semibold">{variant.priceBreakdown.vecere.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.parkovani && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Parkování</span>
                                <span className="font-semibold">{variant.priceBreakdown.parkovani.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.koordinace && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Koordinace (2 osoby)</span>
                                <span className="font-semibold">{variant.priceBreakdown.koordinace.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.agentura > 0 && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">{variant.id === 3 ? 'Provize agentury, zajištění, doprava' : variant.id === 4 ? 'Agenturní provize (10 %)' : 'Agenturní fee (10 %)'}</span>
                                <span className="font-semibold">{variant.priceBreakdown.agentura.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.skola_smyku && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Škola smyku (4 hod, 45 osob)</span>
                                <span className="font-semibold">{variant.priceBreakdown.skola_smyku.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.priprava && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Příprava + likvidace odpadů</span>
                                <span className="font-semibold">{variant.priceBreakdown.priprava.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.drift && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Kluzná kružnice - Drift</span>
                                <span className="font-semibold">{variant.priceBreakdown.drift.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.zrucnost && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Jízda zručnosti</span>
                                <span className="font-semibold">{variant.priceBreakdown.zrucnost.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.zazemi && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Pronájem zázemí Touax</span>
                                <span className="font-semibold">{variant.priceBreakdown.zazemi.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.ucebna && (
                              <div className="flex justify-between">
                                <span className="text-zinc-300">Učebna pro prezentaci</span>
                                <span className="font-semibold">{variant.priceBreakdown.ucebna.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            {variant.priceBreakdown.sleva && (
                              <div className="flex justify-between text-green-400">
                                <span>Poskytnutá sleva</span>
                                <span className="font-semibold">{variant.priceBreakdown.sleva.toLocaleString('cs-CZ')} Kč</span>
                              </div>
                            )}
                            <div className="border-t border-zinc-700 pt-2 mt-2 flex justify-between text-base">
                              <span className="font-bold">Celkem</span>
                              <span className="font-bold text-[#FDB913]">{variant.price.toLocaleString('cs-CZ')} Kč</span>
                            </div>
                          </div>
                        </div>

                        {/* Contact & PDF */}
                        <div className="flex flex-col gap-4">
                          <div className="flex gap-4">
                            {variant.pdfUrl && (
                              <a
                                href={variant.pdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
                              >
                                <Download className="w-4 h-4" />
                                Detailní nabídka PDF
                              </a>
                            )}
                            
                            {variant.cateringPdfUrl && (
                              <a
                                href={variant.cateringPdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 bg-[#FDB913]/20 hover:bg-[#FDB913]/30 border border-[#FDB913]/50 text-[#FDB913] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
                              >
                                <Utensils className="w-4 h-4" />
                                Catering menu PDF
                              </a>
                            )}
                          </div>
                          
                          <button
                            onClick={() => selectVariant(variant)}
                            className="w-full bg-[#FDB913] hover:bg-[#FDB913]/90 text-black px-8 py-3 rounded-lg font-bold transition-colors"
                          >
                            Vybrat tuto variantu
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

// Pricing Section
const PricingSection = ({ selectedVariant, exportToPDF }) => (
  <section id="pricing-section" className="py-24 px-6 bg-[#050505] border-t border-zinc-800">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-4">
          Cenová kalkulace
        </h2>
        <p className="text-zinc-400">
          Vybraná varianta: <span className="text-[#FDB913] font-semibold">{selectedVariant.name}</span>
        </p>
      </div>

      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 mb-8">
        <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
          <Car className="w-6 h-6 text-[#FDB913]" />
          Rozpis nákladů
        </h3>

        <div className="space-y-4 mb-6">
          {selectedVariant.priceBreakdown.kurz && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Kurz bezpečné jízdy (40 osob)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.kurz.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}
          
          {selectedVariant.priceBreakdown.easydrift > 0 && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Easydrift (4 hodiny)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.easydrift.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.zavodni_draha > 0 && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Závodní dráha (1 hodina)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.zavodni_draha.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.jizda_ocr > 0 && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Jízda v OCR + Taxi jízda (2+2 kola)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.jizda_ocr.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.catering > 0 && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Catering - oběd a svačina vč. nápojového režimu (45 osob × 450 Kč)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.catering.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.strelnice && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Střelnice (45 osob × 1 000 Kč)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.strelnice.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.plavba && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Plavba lodí s cateringem (45 osob × 900 Kč)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.plavba.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.wellness && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Wellness & Sauny Maximus (45 osob × 1 000 Kč)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.wellness.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.vecere && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Večeře v restauraci (45 osob × 600 Kč)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.vecere.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.parkovani && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Parkování</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.parkovani.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.koordinace && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Koordinace (2 osoby)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.koordinace.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.agentura > 0 && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">{selectedVariant.id === 3 ? 'Provize agentury, zajištění, doprava' : selectedVariant.id === 4 ? 'Agenturní provize (10 %)' : 'Agenturní fee (10 %)'}</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.agentura.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.skola_smyku && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Škola smyku (4 hod, 45 osob)</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.skola_smyku.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.priprava && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Příprava + likvidace odpadů</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.priprava.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.drift && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Kluzná kružnice - Drift</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.drift.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.zrucnost && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Jízda zručnosti</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.zrucnost.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.zazemi && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Pronájem zázemí Touax</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.zazemi.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.ucebna && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-zinc-300">Učebna pro prezentaci</span>
              <span className="font-bold text-lg">{selectedVariant.priceBreakdown.ucebna.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}

          {selectedVariant.priceBreakdown.sleva && (
            <div className="flex justify-between items-center py-3 border-b border-zinc-800">
              <span className="text-green-400">Poskytnutá sleva</span>
              <span className="font-bold text-lg text-green-400">{selectedVariant.priceBreakdown.sleva.toLocaleString('cs-CZ')} Kč</span>
            </div>
          )}
        </div>

        <div className="bg-[#FDB913] text-black rounded-xl p-6 flex justify-between items-center">
          <span className="text-xl font-bold">CELKOVÁ INVESTICE</span>
          <span className="text-3xl font-bold">{selectedVariant.price.toLocaleString('cs-CZ')} Kč</span>
        </div>

        <div className="mt-6 text-xs text-zinc-500">
          * Uvedené ceny jsou bez DPH
        </div>
      </div>

      {/* Conditions */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 mb-8">
        <h4 className="font-bold mb-4">Podmínky</h4>
        <ul className="space-y-2 text-sm text-zinc-400">
          <li>• Maximální rozpočet: 200 000 Kč bez DPH</li>
          <li>• Kapacita: 45 osob (40 zákazníků + 5 CTS)</li>
          <li>• Uvedené ceny jsou bez DPH</li>
          <li>• Termín: květen / červen 2027</li>
          <li>• Catering lze flexibilně upravit dle rozpočtu</li>
        </ul>
      </div>

      {/* Export PDF Button */}
      <button
        onClick={exportToPDF}
        className="w-full bg-[#FDB913] hover:bg-[#FDB913]/90 text-black px-8 py-4 rounded-lg font-bold text-lg transition-colors flex items-center justify-center gap-3"
      >
        <Download className="w-5 h-5" />
        Stáhnout kompletní nabídku PDF
      </button>
    </div>
  </section>
);

// CTA Section
const CTASection = () => (
  <section className="py-24 px-6 bg-[#121212]">
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="font-['Exo_2'] text-4xl md:text-5xl font-bold tracking-tight mb-6">
        Další kroky
      </h2>
      <p className="text-zinc-400 text-lg mb-12 max-w-2xl mx-auto">
        Stáhněte si .pdf nabídku dle vaší volby a uložte ji pro další využití. Kontaktujte nás pro případné upřesňující dotazy, nebo doladění nabídky.
      </p>

      {/* Contact Info */}
      <div className="mt-16 grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Phone className="w-8 h-8 text-[#FDB913] mx-auto mb-3" />
          <div className="text-sm text-zinc-400 mb-1">Telefon</div>
          <a href="tel:+420773550880" className="text-white hover:text-[#FDB913] font-semibold transition-colors">
            +420 773 550 880
          </a>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-[#FDB913] transition-colors">
          <Mail className="w-8 h-8 text-[#FDB913] mx-auto mb-3" />
          <div className="text-sm text-zinc-400 mb-1">Email</div>
          <a href="mailto:info@vseproakci.cz" className="text-white hover:text-[#FDB913] font-semibold transition-colors">
            info@vseproakci.cz
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default BestDriveFleetPage;
